<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button
    type="button"
    class="btn close"
    (click)="close.emit()"
    aria-label="Close"
    rippleEffect>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
